var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live",
    clipPath: "url(#clip0_8876_840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.1849 0.370371H4.81456C2.35996 0.370371 0.370117 2.36022 0.370117 4.81482V55.1852C0.370117 57.6398 2.35996 59.6296 4.81456 59.6296H55.1849C57.6395 59.6296 59.6294 57.6398 59.6294 55.1852V4.81482C59.6294 2.36022 57.6395 0.370371 55.1849 0.370371Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.0001 56.6667C33.2729 56.6667 35.9261 54.0135 35.9261 50.7407C35.9261 47.4679 33.2729 44.8148 30.0001 44.8148C26.7273 44.8148 24.0742 47.4679 24.0742 50.7407C24.0742 54.0135 26.7273 56.6667 30.0001 56.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.9043 49.6444V51.837",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.0967 49.6444V51.837",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.2959 7.1037H12.2218",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.2959 12.2815H22.1181",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.2959 17.4667H18.8589",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.2959 22.6519H17.6144",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.2959 27.837H16.9403",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.2959 33.0222H17.9922",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M6.2959 38.2074H21.1107",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.2959 43.3852H14.9255",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M35.9261 41.3111C44.1081 41.3111 50.741 34.6783 50.741 26.4963C50.741 18.3143 44.1081 11.6815 35.9261 11.6815C27.7441 11.6815 21.1113 18.3143 21.1113 26.4963C21.1113 34.6783 27.7441 41.3111 35.9261 41.3111Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M35.9263 35.7556C41.04 35.7556 45.1855 31.61 45.1855 26.4963C45.1855 21.3825 41.04 17.237 35.9263 17.237C30.8125 17.237 26.667 21.3825 26.667 26.4963C26.667 31.61 30.8125 35.7556 35.9263 35.7556Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M35.9264 30.2C37.9719 30.2 39.6301 28.5418 39.6301 26.4963C39.6301 24.4508 37.9719 22.7926 35.9264 22.7926C33.8809 22.7926 32.2227 24.4508 32.2227 26.4963C32.2227 28.5418 33.8809 30.2 35.9264 30.2Z",
    stroke: "#1E1F22",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.3849 7.8963L51.9108 10.5185L54.5256 11.037L51.3849 14.1778L48.7627 13.6593L48.2441 11.037L51.3849 7.8963Z",
    stroke: "#1E1F22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M52.9552 12.6074L50.3404 12.0889L49.8145 9.46667",
    stroke: "#1E1F22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M51.911 10.5185L35.9258 26.4963",
    stroke: "#1E1F22",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8876_840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.4071875bc4227b4ca085c0b40a162d1b.svg";
export { ForwardRef as ReactComponent };